import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BusinessCcrReportBlockData from '../../../Models/Content/BusinessCcrReportBlockData';
import BusinessCcrReportMain from './BusinessCcrReportMain';

export default class BusinessCcrReportBlock extends EpiComponent<BusinessCcrReportBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <BusinessCcrReportMain iContent={this.props.data} context={this.getContext()} />;
  }
}
